import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-generic-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './generic-button.component.html',
  styleUrls: ['./generic-button.component.css']
})
export class GenericButtonComponent {
  @Input() text: string = '';
  @Input() type: 'confirm' | 'test' | 'danger' | 'solid' = 'confirm';
  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() minWidth: string = '';
  @Input() singleLine: boolean = false;

  get buttonClass(): string {
    return `btn-${this.type}`;
  }

  get buttonStyle(): string {
    let styles = '';
    
    if (this.minWidth) {
      styles += `min-width: ${this.minWidth};`;
    }
    
    if (this.singleLine) {
      styles += 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;';
    }
    
    return styles;
  }
}

export default GenericButtonComponent; 